import { Grid, IconButton } from '@material-ui/core';
import EditOrderButtonIcon from 'assets/icons/edit_order_button.svg';
import EditOrderButtonGreyIcon from 'assets/icons/edit_order_button_grey.svg';
import AddOrderButtonIcon from 'assets/icons/add_order_button.svg';
import AddOrderButtonGreyIcon from 'assets/icons/add_order_button_grey.svg';
import CancelOrderButtonIcon from 'assets/icons/cancel_order_button.svg';
import CancelOrderButtonGreyIcon from 'assets/icons/cancel_order_button_grey.svg';
import MakePaymentButtonIcon from 'assets/icons/make_payment_button.svg';
import MakePaymentButtonGreyIcon from 'assets/icons/make_payment_button_grey.svg';
import PickupButtonIcon from 'assets/icons/pickup_button.svg';
import PickupButtonGreyIcon from 'assets/icons/pickup_button_grey.svg';
import { PosPermission } from 'generated/graphql';
import { usePermissionChecker } from 'helpers/hooks/usePermissionChecker';
import React from 'react';
import { useHistory } from 'react-router';
interface TakeawayProps {
	pickupDialog: any;
	cancelDialog: any;
	paymentDialog: any;
	addOrderPath: any;
	discountPath: any;
	outstandingAmount: any;
	orderStatus: any;
	outletID: any;
	serviceMode?: string | null;
	deliveryPlatform?: string | null;
	readyOrderDialog?: any;
	isReadyOrder?: boolean;
	style?: React.CSSProperties;
	onEditGrabOrder?: () => void;
	grabOrderItemCount?: number;
	grabOrderState?: string | null;
	grabMerchantID?: string | null;
}

export const TakeawayFooter = (props: TakeawayProps) => {
	const { handlePermDisabled } = usePermissionChecker();
	const history = useHistory();
	const {
		pickupDialog,
		cancelDialog,
		paymentDialog,
		addOrderPath,
		discountPath,
		outstandingAmount,
		orderStatus,
		outletID,
		serviceMode,
		deliveryPlatform,
		readyOrderDialog,
		isReadyOrder,
		style,
		onEditGrabOrder,
		grabOrderItemCount = 0,
		grabOrderState,
		grabMerchantID,
	} = props;

	// Hide Discount and Make Payment buttons for GrabFood delivery orders
	const isGrabFoodDelivery =
		serviceMode === 'DELIVERY' && deliveryPlatform === 'GrabFood';

	const showEditOrderButton =
		isGrabFoodDelivery &&
		!!onEditGrabOrder &&
		grabOrderItemCount > 1 &&
		!grabOrderState &&
		!!grabMerchantID;

	const colWidth = showEditOrderButton ? 2 : undefined;

	return (
		<div className="footer" style={{ ...style }}>
			<Grid container>
				<Grid item xs={colWidth || 2} style={{ textAlign: 'center' }}>
					<IconButton
						style={{ paddingBottom: '1px', paddingTop: '7px' }}
						onClick={() => {
							pickupDialog(true);
						}}
						disabled={
							handlePermDisabled({
								outletID: outletID,
								permEnum: PosPermission.TakeawayPickUpUpdate,
							}) ||
							(orderStatus === 'PICKED_UP' ||
							orderStatus === 'CANCELLED' ||
							orderStatus === 'OPEN'
								? true
								: false)
						}
					>
						<img
							style={{
								padding: '4px',
								width: '26px',
								height: '26px',
							}}
							color={'inherit'}
							src={
								handlePermDisabled({
									outletID: outletID,
									permEnum: PosPermission.TakeawayPickUpUpdate,
								}) ||
								orderStatus === 'PICKED_UP' ||
								orderStatus === 'CANCELLED' ||
								orderStatus === 'OPEN'
									? PickupButtonGreyIcon
									: PickupButtonIcon
							}
						/>
					</IconButton>
					<div className="desc">Pick Up</div>
				</Grid>

				<Grid item xs={colWidth || 3} style={{ textAlign: 'center' }}>
					<IconButton
						style={{ paddingBottom: '1px', paddingTop: '7px' }}
						onClick={() => {
							history.push(addOrderPath);
						}}
						disabled={
							isGrabFoodDelivery ||
							handlePermDisabled({
								outletID: outletID,
								permEnum: PosPermission.TakeawayAddOrderCreate,
							}) ||
							(orderStatus === 'PICKED_UP' ||
							orderStatus === 'CANCELLED' ||
							orderStatus === 'CLOSED'
								? true
								: false)
						}
					>
						<img
							style={{
								padding: '4px',
								width: '26px',
								height: '26px',
							}}
							src={
								isGrabFoodDelivery ||
								handlePermDisabled({
									outletID: outletID,
									permEnum: PosPermission.TakeawayAddOrderCreate,
								}) ||
								orderStatus === 'PICKED_UP' ||
								orderStatus === 'CANCELLED' ||
								orderStatus === 'CLOSED'
									? AddOrderButtonGreyIcon
									: AddOrderButtonIcon
							}
						/>
					</IconButton>
					<div className="desc">Add Order</div>
				</Grid>

				<Grid item xs={colWidth || 2} style={{ textAlign: 'center' }}>
					<IconButton
						style={{ paddingBottom: '1px', paddingTop: '7px' }}
						onClick={() => {
							cancelDialog(true);
						}}
						disabled={
							// serviceMode === 'DELIVERY' ||
							handlePermDisabled({
								outletID: outletID,
								permEnum: PosPermission.TakeawayCancelOrderUpdate,
							}) ||
							(orderStatus === 'PICKED_UP' ||
							orderStatus === 'CANCELLED' ||
							orderStatus === 'CLOSED'
								? true
								: false)
						}
					>
						<img
							style={{
								width: '36px',
								height: '36px',
							}}
							src={
								// serviceMode === 'DELIVERY' ||
								handlePermDisabled({
									outletID: outletID,
									permEnum: PosPermission.TakeawayCancelOrderUpdate,
								}) ||
								orderStatus === 'PICKED_UP' ||
								orderStatus === 'CANCELLED' ||
								orderStatus === 'CLOSED'
									? CancelOrderButtonGreyIcon
									: CancelOrderButtonIcon
							}
						/>
					</IconButton>
					<div className="desc">Cancel Order</div>
				</Grid>

				{showEditOrderButton ? (
					<Grid item xs={2} style={{ textAlign: 'center' }}>
						<IconButton
							style={{ paddingBottom: '1px', paddingTop: '7px' }}
							onClick={onEditGrabOrder}
							disabled={
								handlePermDisabled({
									outletID: outletID,
									permEnum: PosPermission.TakeawayTakeawayVoidOrderItemVoid,
								}) ||
								orderStatus === 'PICKED_UP' ||
								orderStatus === 'CANCELLED' ||
								orderStatus === 'CLOSED'
							}
						>
							<img
								style={{
									padding: '4px',
									width: '26px',
									height: '26px',
								}}
								src={
									handlePermDisabled({
										outletID: outletID,
										permEnum: PosPermission.TakeawayTakeawayVoidOrderItemVoid,
									}) ||
									orderStatus === 'PICKED_UP' ||
									orderStatus === 'CANCELLED' ||
									orderStatus === 'CLOSED'
										? EditOrderButtonGreyIcon
										: EditOrderButtonIcon
								}
							/>
						</IconButton>
						<div className="desc">Edit Order</div>
					</Grid>
				) : null}

				<Grid item xs={colWidth || 3} style={{ textAlign: 'center' }}>
					{isGrabFoodDelivery ? (
						<IconButton
							style={{ paddingBottom: '1px', paddingTop: '7px' }}
							onClick={() => {
								if (readyOrderDialog) {
									readyOrderDialog(true);
								}
							}}
							disabled={
								isReadyOrder === true ||
								handlePermDisabled({
									outletID: outletID,
									permEnum: PosPermission.TakeawayAddOrderCreate,
								}) ||
								(orderStatus === 'PICKED_UP' ||
								orderStatus === 'CANCELLED' ||
								orderStatus === 'CLOSED'
									? true
									: false)
							}
						>
							<img
								style={{
									padding: '4px',
									width: '26px',
									height: '26px',
								}}
								src={
									isReadyOrder === true ||
									handlePermDisabled({
										outletID: outletID,
										permEnum: PosPermission.TakeawayAddOrderCreate,
									}) ||
									orderStatus === 'PICKED_UP' ||
									orderStatus === 'CANCELLED' ||
									orderStatus === 'CLOSED'
										? AddOrderButtonGreyIcon
										: AddOrderButtonIcon
								}
							/>
						</IconButton>
					) : (
						<IconButton
							style={{ paddingBottom: '1px', paddingTop: '7px' }}
							onClick={() => {
								history.push(discountPath);
							}}
							disabled={
								handlePermDisabled({
									outletID: outletID,
									permEnum: PosPermission.TakeawayAddOrderCreate,
								}) ||
								(orderStatus === 'PICKED_UP' ||
								orderStatus === 'CANCELLED' ||
								orderStatus === 'CLOSED'
									? true
									: false)
							}
						>
							<img
								style={{
									padding: '4px',
									width: '26px',
									height: '26px',
								}}
								src={
									handlePermDisabled({
										outletID: outletID,
										permEnum: PosPermission.TakeawayAddOrderCreate,
									}) ||
									orderStatus === 'PICKED_UP' ||
									orderStatus === 'CANCELLED' ||
									orderStatus === 'CLOSED'
										? AddOrderButtonGreyIcon
										: AddOrderButtonIcon
								}
							/>
						</IconButton>
					)}
					<div className="desc">
						{isGrabFoodDelivery ? 'Ready Order' : 'Discount'}
					</div>
				</Grid>

				<Grid item xs={colWidth || 2} style={{ textAlign: 'center' }}>
					<IconButton
						style={{ paddingBottom: '1px', paddingTop: '7px' }}
						onClick={() => {
							if (outstandingAmount !== 0) {
								paymentDialog(true);
							}
						}}
						disabled={
							isGrabFoodDelivery ||
							handlePermDisabled({
								outletID: outletID,
								permEnum: PosPermission.TakeawayMakePaymentCreate,
							}) ||
							(orderStatus === 'PICKED_UP' ||
							orderStatus === 'CANCELLED' ||
							orderStatus === 'CLOSED'
								? true
								: false)
						}
					>
						<img
							style={{
								padding: '4px',
								width: '26px',
								height: '26px',
							}}
							src={
								isGrabFoodDelivery ||
								handlePermDisabled({
									outletID: outletID,
									permEnum: PosPermission.TakeawayMakePaymentCreate,
								}) ||
								orderStatus === 'PICKED_UP' ||
								orderStatus === 'CANCELLED' ||
								orderStatus === 'CLOSED'
									? MakePaymentButtonGreyIcon
									: MakePaymentButtonIcon
							}
						/>
					</IconButton>
					<div className="desc">Make Payment</div>
				</Grid>
			</Grid>
		</div>
	);
};
